import React from 'react'
import Layout from '../../components/layouts/Layout'
import DataView from './components/DataView'

function View() {
  return (
    <Layout>
      <div className="page">

        <div className="card radius-10">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <h2>Data Capture List</h2>
              </div>
              <div className="col-12">
                <DataView />
              </div>
            </div>

          </div>
        </div>
      </div>

    </Layout>
  )
}

export default View
